{
  "INTEGRATION_APPS": {
    "FETCHING": "A procurar integrações",
    "NO_HOOK_CONFIGURED": "Não há integrações {integrationId} configuradas nesta conta.",
    "HEADER": "Aplicações",
    "STATUS": {
      "ENABLED": "Ativado",
      "DISABLED": "Desativado"
    },
    "CONFIGURE": "Configurar",
    "ADD_BUTTON": "Adicionar um novo hook",
    "DELETE": {
      "TITLE": {
        "INBOX": "Confirmar exclusão",
        "ACCOUNT": "Desconectar"
      },
      "MESSAGE": {
        "INBOX": "Tem a certeza que pretende excluir?",
        "ACCOUNT": "Tem certeza que deseja desligar?"
      },
      "CONFIRM_BUTTON_TEXT": {
        "INBOX": "Sim, excluir",
        "ACCOUNT": "Sim, desconectar"
      },
      "CANCEL_BUTTON_TEXT": "Cancelar",
      "API": {
        "SUCCESS_MESSAGE": "Hook excluído com sucesso",
        "ERROR_MESSAGE": "Não foi possível conectar ao servidor Woot, por favor, tente novamente mais tarde"
      }
    },
    "LIST": {
      "FETCHING": "A procurar hooks de integração",
      "INBOX": "Caixa de entrada",
      "EDIT": {
        "BUTTON_TEXT": "Editar"
      },
      "DELETE": {
        "BUTTON_TEXT": "Excluir"
      }
    },
    "ADD": {
      "FORM": {
        "INBOX": {
          "LABEL": "Selecionar caixa de entrada",
          "PLACEHOLDER": "Selecionar caixa de entrada"
        },
        "SUBMIT": "Criar",
        "CANCEL": "Cancelar"
      },
      "API": {
        "SUCCESS_MESSAGE": "Hook de integração adicionado com sucesso",
        "ERROR_MESSAGE": "Não foi possível conectar ao servidor Woot, por favor, tente novamente mais tarde"
      }
    },
    "EDIT": {
      "TITLE": "Editar {name}",
      "FORM": {
        "SUBMIT": "Atualizar",
        "CANCEL": "Cancelar"
      },
      "API": {
        "SUCCESS_MESSAGE": "Hook de integração atualizado com sucesso",
        "ERROR_MESSAGE": "Não foi possível ligar ao servidor de chat, tente novamente mais tarde"
      }
    },
    "CONNECT": {
      "BUTTON_TEXT": "Conectar"
    },
    "DISCONNECT": {
      "BUTTON_TEXT": "Desconectar"
    },
    "SIDEBAR_DESCRIPTION": {
      "CUSTOM_DATA_PROVIDER": "Fetch data from your own server and display it in the conversation sidebar. Returns HTML (shown in an iframe) or JSON (shown as a key/value list).",
      "DIALOGFLOW": "Dialogflow is a natural language processing platform for building conversational interfaces. Integrating it with {installationName} lets bots handle queries first and transfer them to agents when needed. It helps qualify leads and reduce agent workload by answering FAQs. To add Dialogflow, create a Service Account in Google Console and share the credentials. Refer to the docs for details",
      "DAKTELA": "Sincronize e-mails e webchats com a sua conta Daktela.",
      "RETINO": "A Retino organiza a gestão de devoluções e reclamações.",
      "MAILSHIP": "O Mailship é um sistema de gestão de armazém e cumprimento de encomendas. Consulte o estado de encomendas, o rastreio e os detalhes de expedição.",
      "RAYNET": "Ligue a sua conta Raynet CRM para aceder aos dados dos seus clientes. Adicione uma ligação com o seu nome de utilizador e token de API Raynet."
    },
    "TEST_CONNECTION": {
      "BUTTON": "Testar ligação",
      "SUCCESS": "Ligação bem-sucedida",
      "ERROR": "A ligação falhou. Verifique as suas credenciais."
    }
  }
}
